window.closeAllSections = function() {
  var navBar = document.querySelector('.mobile-nav-wrapper');
  if (navBar) navBar.classList.remove('nav-hidden');

  var allCatModals = document.querySelectorAll('.categories-modal');
  allCatModals.forEach(function(modal) {
    modal.classList.remove('is-open');
  });

  var allSortModals = document.querySelectorAll('.custom-bottom-sheet');
  allSortModals.forEach(function(modal) {
    modal.classList.remove('active');
  });

  var openDetails = document.querySelectorAll('details[open]');
  openDetails.forEach(function(detail) {
    if (detail.classList.contains('menu-drawer-container') || detail.classList.contains('mobile-facets__wrapper') || detail.closest('.mobile-facets__wrapper')) {
      var closeBtn = detail.querySelector('.mobile-facets__close, .mobile-facets__close-button');
      if (closeBtn) {
        closeBtn.click();
      } else {
        detail.removeAttribute('open');
        var summary = detail.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }
  });

  document.body.style.overflow = '';
  document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
};

window.toggleCategories = function() {
  var modal = document.getElementById('CategoriesModal');
  var isOpen = modal.classList.contains('is-open');
  var navBar = document.querySelector('.mobile-nav-wrapper');

  window.closeAllSections();

  if (!isOpen) {
    if (navBar) navBar.classList.add('nav-hidden');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(window.updateActiveOnScroll, 100);
  }
};

window.openSortModal = function() {
  var modal = document.getElementById('SortModal');
  var isOpen = modal.classList.contains('active');
  var navBar = document.querySelector('.mobile-nav-wrapper');

  window.closeAllSections();

  if (!isOpen) {
    if (navBar) navBar.classList.add('nav-hidden');
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';

    var currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'best-selling';
    document.querySelectorAll('.sort-option').forEach(el => el.classList.remove('selected'));
    var activeBtn = document.querySelector(`.sort-option[data-value="${currentSort}"]`);
    if (activeBtn) activeBtn.classList.add('selected');
  }
};

window.closeSortModal = function() {
  window.closeAllSections();
};

window.applySort = function(sortValue) {
  var btn = document.querySelector(`.sort-option[data-value="${sortValue}"]`);
  if (btn) btn.innerHTML = '<span>🔄 Loading...</span>';

  var currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('sort_by', sortValue);
  window.location.href = currentUrl.toString();
};

window.scrollToCategory = function(targetId) {
  var element = document.getElementById(targetId);
  var container = document.getElementById('mainContentArea');

  var allLinks = document.querySelectorAll('.sidebar-item');
  allLinks.forEach(function(link) {
    link.classList.remove('active');
    if (link.getAttribute('data-target') === targetId) link.classList.add('active');
  });

  if (element && container) {
    container.scrollTo({
      top: element.offsetTop - 20,
      behavior: 'smooth'
    });
    container.classList.add('disable-spy');
    setTimeout(() => {
      container.classList.remove('disable-spy');
    }, 800);
  }
};

window.updateActiveOnScroll = function() {
  var container = document.getElementById('mainContentArea');
  if (!container || container.classList.contains('disable-spy')) return;

  var sections = document.querySelectorAll('.tab-content-item');
  var sidebarLinks = document.querySelectorAll('.sidebar-item');
  var scrollPosition = container.scrollTop;
  var triggerPoint = scrollPosition + container.offsetHeight / 2;
  var currentId = '';

  sections.forEach(function(section) {
    if (section.offsetTop <= triggerPoint) currentId = section.getAttribute('id');
  });

  if (container.scrollHeight - container.scrollTop <= container.offsetHeight + 10) {
    if (sections.length > 0) currentId = sections[sections.length - 1].getAttribute('id');
  }

  sidebarLinks.forEach(function(link) {
    if (link.getAttribute('data-target') === currentId) {
      if (!link.classList.contains('active')) {
        sidebarLinks.forEach((l) => l.classList.remove('active'));
        link.classList.add('active');
        link.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  var container = document.getElementById('mainContentArea');
  if (container) container.addEventListener('scroll', window.updateActiveOnScroll);

  var firstSidebarItem = document.querySelector('.sidebar-item');
  if (firstSidebarItem) firstSidebarItem.classList.add('active');

  const myFilterBtn = document.getElementById('mobile-filter-btn');
  if (myFilterBtn) {
    myFilterBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var navBar = document.querySelector('.mobile-nav-wrapper');
      var alreadyOpenFilter = document.querySelector('details.mobile-facets__wrapper[open]');

      if (alreadyOpenFilter) {
        window.closeAllSections();
      } else {
        window.closeAllSections();
        if (navBar) navBar.classList.add('nav-hidden');

        let trigger = document.querySelector('summary.mobile-facets__open');
        if (!trigger) trigger = document.querySelector('.mobile-facets__open-wrapper');
        if (!trigger) trigger = document.querySelector('[id^="FacetDrawer-"]');

        if (trigger) trigger.click();
      }
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.mobile-facets__close') || e.target.closest('.mobile-facets__close-button')) {
      var navBar = document.querySelector('.mobile-nav-wrapper');
      if (navBar) navBar.classList.remove('nav-hidden');
    }
  });

  const mobileCartCount = document.getElementById('mobile-cart-count');
  async function refreshCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const count = cart.item_count;
      if (mobileCartCount) {
        mobileCartCount.innerText = count;
        mobileCartCount.style.display = count > 0 ? 'flex' : 'none';
      }
    } catch (e) {}
  }
  refreshCartCount();
});


window.triggerBuyNow = function(btn) {

  if (!btn) return;

  const floBtn = document.getElementById('flo-buy-now-btn');
  if (!floBtn) return;

  btn.disabled = true;
  btn.innerHTML = `<span class="sticky-spinner"></span>`;

  floBtn.click();

  // 🔥 AUTO RESET after 3 seconds
  setTimeout(() => {
    btn.innerHTML = "Buy Now";
    btn.disabled = false;
  }, 3000);
};

 async function handleStickyAddToCart(btn) {

  if (btn.dataset.added === "true") {
    window.location.href = "/cart";
    return;
  }

  try {
    btn.disabled = true;
    btn.innerHTML = `
      <span class="sticky-spinner"></span>
      Adding...
    `;

    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) throw new Error("Form not found");

    const formData = new FormData(form);

    // 🔥 IMPORTANT: ask Shopify to return updated sections
    formData.append("sections", "cart-icon-bubble,cart-drawer");
    formData.append("sections_url", window.location.pathname);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.sections) {

      // Update cart icon bubble
      const cartBubble = document.getElementById("cart-icon-bubble");
      if (cartBubble && data.sections["cart-icon-bubble"]) {
        cartBubble.innerHTML = data.sections["cart-icon-bubble"];
      }

      // Update cart drawer if exists
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && data.sections["cart-drawer"]) {
        cartDrawer.innerHTML = data.sections["cart-drawer"];
      }
    }

    // Success state
    btn.innerText = "Go to Cart";
    btn.dataset.added = "true";
    btn.disabled = false;

  } catch (error) {
    console.error(error);
    btn.innerText = "Try Again";
    btn.disabled = false;
  }
}

window.addEventListener("pageshow", function(event) {

  if (event.persisted) {
    console.log("Page restored from bfcache");
  }

  // Reset Sticky Buy Now
  document.querySelectorAll('.action-btn-buy').forEach(btn => {
    btn.innerHTML = "Buy Now";
    btn.disabled = false;
  });

  // Reset Sticky Add to Cart
  document.querySelectorAll('.action-btn-cart').forEach(btn => {
    if (btn.dataset.added !== "true") {
      btn.innerHTML = "Add to Cart";
      btn.disabled = false;
    }
  });

});
